export default {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'mediaSingle',
            'heading_with_no_marks',
            'mediaGroup',
        ],
    ],
    minItems: 1,
    allowUnsupportedBlock: true,
};
//# sourceMappingURL=nestedExpand_content.js.map